import { c as _c } from "react/compiler-runtime";
import type { FetchChatTranslateParams } from '@module/apis/client-side/chat/type';
import Button from '@module/components/Button/Button';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import { useFetchChatTranslateMutation } from '@module/queries/chat/chatQueryHooks';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import useSocketStore from '@module/stores/useSocketStore';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message';
import { truncateNormalChatMessage } from '@module/utils/truncateText';
import { useState } from 'react';
interface Props {
  chatData: NormalChatMessage;
  setTranslatedMessage: (message: string) => void;
  filtered?: boolean; // 필터링된 메시지인지 여부
  filteredMessage?: string; // 필터 안내 메세지 ex)금칙어가 포함되어 있습니다.
  className?: string;
  onError: ((error: Error, variables: FetchChatTranslateParams, context: unknown) => Promise<unknown> | unknown) | undefined;
  // 해당 방송의 bj인지 여부
  onClickWithoutLogin: () => void;
  isRoomMaster?: boolean;
}
function ChatTranslateButton(t0) {
  const $ = _c(29);
  const {
    chatData,
    setTranslatedMessage,
    filtered,
    filteredMessage,
    className,
    onError,
    onClickWithoutLogin,
    isRoomMaster
  } = t0;
  const shouldForceDarkStyle = useChatPanelStore(_temp);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const token = useSocketStore(_temp2);
  let t1;
  if ($[0] !== chatData) {
    t1 = truncateNormalChatMessage(chatData);
    $[0] = chatData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const message = t1;
  const [isTranslated, setIsTranslated] = useState(false);
  let t2;
  if ($[2] !== setTranslatedMessage) {
    t2 = data => {
      setTranslatedMessage(data.data.translatedMessage);
      setIsTranslated(true);
    };
    $[2] = setTranslatedMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onError || $[5] !== t2) {
    t3 = {
      onSuccess: t2,
      onError
    };
    $[4] = onError;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    mutate,
    isPending
  } = useFetchChatTranslateMutation(t3);
  let t4;
  if ($[7] !== chatData || $[8] !== filtered || $[9] !== filteredMessage || $[10] !== isLogin || $[11] !== isRoomMaster || $[12] !== message || $[13] !== mutate || $[14] !== onClickWithoutLogin || $[15] !== setTranslatedMessage || $[16] !== token) {
    t4 = e => {
      e.stopPropagation();
      if (!token) {
        return;
      }
      if (!isLogin) {
        onClickWithoutLogin?.();
        return;
      }
      if (filtered) {
        setTranslatedMessage(filteredMessage || "");
        setIsTranslated(true);
        return;
      }
      mutate({
        message,
        src_lang: chatData.data.lang?.[0] || "ko",
        target_lang: SettingConfig.LANG,
        ...(isRoomMaster ? {
          offset: chatData.offset
        } : {}),
        token
      });
    };
    $[7] = chatData;
    $[8] = filtered;
    $[9] = filteredMessage;
    $[10] = isLogin;
    $[11] = isRoomMaster;
    $[12] = message;
    $[13] = mutate;
    $[14] = onClickWithoutLogin;
    $[15] = setTranslatedMessage;
    $[16] = token;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const handleClick = t4;
  let t5;
  if ($[18] !== className || $[19] !== shouldForceDarkStyle) {
    t5 = cn("ml-2", className, {
      "border-system-gray-700": shouldForceDarkStyle,
      "border-0": SettingConfig.LANG === "ko"
    });
    $[18] = className;
    $[19] = shouldForceDarkStyle;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Button.Icon name="TranslateFilled" iconSize={12} color="black" />;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn({
      "font-normal text-[12px] hover:underline": SettingConfig.LANG === "ko"
    });
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Button.Text textColor="system-gray-black" className={t7}>{SettingConfig.LANG !== "ko" ? "\u7FFB\u8A33" : "\uBC88\uC5ED"}</Button.Text>;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== handleClick || $[25] !== isPending || $[26] !== isTranslated || $[27] !== t5) {
    t9 = <Button height="small" variant="tertiary" className={t5} onClick={handleClick} isPending={isPending} disabled={isTranslated}>{t6}{t8}</Button>;
    $[24] = handleClick;
    $[25] = isPending;
    $[26] = isTranslated;
    $[27] = t5;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
}
function _temp2(state_0) {
  return state_0.token;
}
function _temp(state) {
  return state.shouldForceDarkStyle();
}
export default ChatTranslateButton;

// 고민 사항: onClick 로직을 훅으로 빼고 ui만을 각 패키지에서 dumb하게 구현하는게 더 나을수도 있겠습니다.